import Cookies from "js-cookie";
/**
 * 存储localStorage
 */
export const setStore = (name, content, expireDay) => {
    if (!name) return;
    if (typeof content !== "string") {
        content = JSON.stringify(content);
    }
    Cookies.set(name, content, { expires: expireDay });
};

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    let content = Cookies.get(name);
    try {
        content = JSON.parse(content);
        return content;
    } catch (e) {
        return content;
    }
};

/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    Cookies.remove(name);
};

/**
 * 存储sessionStorage
 */
export const setSession = (name, content) => {
    if (!name) return;
    if (typeof content !== "string") {
        content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
};

/**
 * 获取sessionStorage
 */
export const getSession = name => {
    if (!name) return;
    return JSON.parse(window.sessionStorage.getItem(name));
};

/**
 * 删除sessionStorage
 */
export const removeCache = name => {
    if (!name) return;
    window.sessionStorage.removeItem(name);
};
